import React from "react";
import "./CancelButton.css";
import { Button } from "react-bootstrap";

export const CancelButton = ({ onClick, children }) => {
  return (
    <Button className="cancel-button" onClick={onClick}>
      <div className="cancel-wrapper">
        <div className="cancel-group-wrapper">
          <div className="cancel-group">
            <div className="cancel-text">{children}</div>
          </div>
        </div>
      </div>
    </Button>
  );
};

export default CancelButton;
